module.exports = __webpack_public_path__ + "img/banner.4a8dccc9.jpg";